export const POPULAR_BANKS_VIEW = 0;
export const SELECT_BANK_VIEW = 1;
export const SELECT_BRANCH_VIEW = 2;
export const CONFIRM_VIEW = 3;
